import type LoginError from './exceptions/loginError';
import type {
	ResetPassword,
	ResetPasswordError
} from './exceptions/resetPasswordError';
import { User, UserAction, UserActionTypes } from './userTypes';

export const loginUserRequest = (payload: User): UserAction => ({
	type: UserActionTypes.USER_LOGIN_REQUEST,
	payload
});

export const loginUserSuccess = (payload: User): UserAction => ({
	type: UserActionTypes.USER_LOGIN_SUCCESS,
	payload
});

export const loginUserFailure = (error: LoginError): UserAction => ({
	type: UserActionTypes.USER_LOGIN_FAILURE,
	error
});

export const logoutUserRequest = (): UserAction => ({
	type: UserActionTypes.USER_LOGOUT_REQUEST
});

export const logoutUserRequestAPI = (): UserAction => ({
	type: UserActionTypes.USER_LOGOUT_REQUEST_API
});

export const logoutUserSuccess = (): UserAction => ({
	type: UserActionTypes.USER_LOGOUT_SUCCESS
});

export const refreshTokenRequest = (): UserAction => ({
	type: UserActionTypes.USER_REFRESH_TOKEN_REQUEST
});

export const refreshTokenRequestAPI = (payload: any): UserAction => {
	return {
		type: UserActionTypes.USER_REFRESH_TOKEN_REQUEST_API,
		payload
	};
};

export const refreshTokenSuccess = (payload: any): UserAction => ({
	type: UserActionTypes.USER_REFRESH_TOKEN_SUCCESS,
	payload
});

export const refreshTokenExpiredFailure = (payload: any): UserAction => ({
	type: UserActionTypes.USER_REFRESH_TOKEN_EXPIRED_FAILURE
});

export const logoutUserFailure = (error: LoginError): UserAction => ({
	type: UserActionTypes.USER_LOGOUT_FAILURE,
	error
});

export const userGetUserRequest = (): UserAction => ({
	type: UserActionTypes.USER_GET_USER_REQUEST
});

export const userGetUserSuccess = (payload: User): UserAction => ({
	type: UserActionTypes.USER_GET_USER_SUCCESS,
	payload
});

export const userGetUserFailure = (error: LoginError): UserAction => ({
	type: UserActionTypes.USER_GET_USER_FAILURE,
	error
});

export const userGetUserByEmail = (payload: any): UserAction => ({
	type: UserActionTypes.USER_GET_USER_BY_EMAIL_REQUEST,
	payload
});

export const userGetUserByEmailSuccess = (payload): UserAction => ({
	type: UserActionTypes.USER_GET_USER_BY_EMAIL_SUCCESS,
	payload
});

export const userGetUserByEmailFailure = (payload): UserAction => ({
	type: UserActionTypes.USER_GET_USER_BY_EMAIL_FAILURE,
	payload
});

export const userGetUserByEmailNoUser = (): UserAction => ({
	type: UserActionTypes.USER_GET_USER_BY_EMAIL_NO_USER
});

export const userGetUsersRequest = (): UserAction => ({
	type: UserActionTypes.USER_GET_USERS_REQUEST
});

export const userGetUsersSuccess = (payload: User[]): UserAction => ({
	type: UserActionTypes.USER_GET_USERS_SUCCESS,
	payload
});

export const userGetUsersFailure = (error: LoginError): UserAction => ({
	type: UserActionTypes.USER_GET_USERS_FAILURE,
	error
});

export const resetPasswordRequest = (payload: ResetPassword): UserAction => ({
	type: UserActionTypes.USER_RESET_PASSWORD_REQUEST,
	payload
});

export const resetPasswordSuccess = (payload: User): UserAction => ({
	type: UserActionTypes.USER_RESET_PASSWORD_SUCCESS,
	payload
});

export const resetPasswordFailure = (
	error: ResetPasswordError
): UserAction => ({
	type: UserActionTypes.USER_RESET_PASSWORD_FAILURE,
	error
});

export const adminResetPasswordRequest = (payload): UserAction => ({
	type: UserActionTypes.USER_ADMIN_RESET_PASSWORD_REQUEST,
	payload
});

export const adminResetPasswordSuccess = (payload: User): UserAction => ({
	type: UserActionTypes.USER_ADMIN_RESET_PASSWORD_SUCCESS,
	payload
});

export const adminResetPasswordFailure = (
	error: ResetPasswordError
): UserAction => ({
	type: UserActionTypes.USER_ADMIN_RESET_PASSWORD_FAILURE,
	error
});

export const userUpdateEmailsLeft = (): UserAction => ({
	type: UserActionTypes.USER_UPDATE_EMAILS_LEFT
});

export const userUpdateEmailsLeftLocal = (payload): UserAction => ({
	type: UserActionTypes.USER_UPDATE_EMAILS_LEFT_LOCAL,
	payload
});

export const userIncreaseEmailsLeft = (): UserAction => ({
	type: UserActionTypes.USER_INCREASE_EMAILS_LEFT
});

export const userUpdateEmailsLimitRequest = (): UserAction => ({
	type: UserActionTypes.USER_UPDATE_EMAILS_LIMIT_REQUEST
});

export const userUpdateEmailsLimitSuccess = (): UserAction => ({
	type: UserActionTypes.USER_UPDATE_EMAILS_LIMIT_SUCCESS
});

export const userUpdateEmailsLimitFailure = (error: Error): UserAction => ({
	type: UserActionTypes.USER_UPDATE_EMAILS_LIMIT_FAILURE,
	error
});

export const userUpdateUserAdminRequest = (payload): UserAction => ({
	type: UserActionTypes.USER_UPDATE_USER_ADMIN_REQUEST,
	payload
});

export const userUpdateUserAdminSuccess = (payload): UserAction => ({
	type: UserActionTypes.USER_UPDATE_USER_ADMIN_SUCCESS,
	payload
});

export const userUpdateUserAdminFailure = (payload): UserAction => ({
	type: UserActionTypes.USER_UPDATE_USER_ADMIN_FAILURE,
	payload
});

export const userAddEmailToken = (payload: any): UserAction => ({
	type: UserActionTypes.USER_ADD_EMAIL_TOKEN,
	payload
});

export const userAddEmailTokenSuccess = (payload: any): UserAction => ({
	type: UserActionTypes.USER_ADD_EMAIL_TOKEN_SUCCESS,
	payload
});

export const userAddEmailTokenFailure = (payload: any): UserAction => ({
	type: UserActionTypes.USER_ADD_EMAIL_TOKEN_FAILURE,
	payload
});

export const userUpdateSubscription = (payload: any): UserAction => ({
	type: UserActionTypes.USER_UPDATE_SUBSCRIPTION,
	payload
});

export const userToggleAddUserModal = (payload: boolean): UserAction => ({
	type: UserActionTypes.USER_TOGGLE_ADD_USER_MODAL,
	payload
});

export const userAddNewUserRequest = (payload: any): UserAction => ({
	type: UserActionTypes.USER_ADD_NEW_USER_REQUEST,
	payload
});

export const userAddNewUserLoading = (): UserAction => ({
	type: UserActionTypes.USER_ADD_NEW_USER_LOADING
});

export const userAddNewUserSuccess = (payload: any): UserAction => ({
	type: UserActionTypes.USER_ADD_NEW_USER_SUCCESS,
	payload
});

export const deleteUserRequest = (payload: any): UserAction => ({
	type: UserActionTypes.USER_DELETE_USER_REQUEST,
	payload
});

export const addHostedEmail = (payload: any): UserAction => ({
	type: UserActionTypes.USER_ADD_HOSTED_EMAIL,
	payload
});

export const deleteUserSuccess = (): UserAction => ({
	type: UserActionTypes.USER_DELETE_USER_SUCCESS
});

export const userToggleAddBccModal = (payload: boolean): UserAction => ({
	type: UserActionTypes.USER_TOGGLE_ADD_BCC_MODAL,
	payload
});

export const userAddNewBccRequest = (payload: any): UserAction => ({
	type: UserActionTypes.USER_ADD_NEW_BCC_REQUEST,
	payload
});

export const userAddNewBccLoading = (): UserAction => ({
	type: UserActionTypes.USER_ADD_NEW_BCC_LOADING
});

export const userAddNewBccSuccess = (payload: any): UserAction => ({
	type: UserActionTypes.USER_ADD_NEW_BCC_SUCCESS,
	payload
});

export const userAddNewBccFailure = (payload: any): UserAction => ({
	type: UserActionTypes.USER_ADD_NEW_BCC_FAILURE
});

export const userAddNewBccSuccessOff = (payload: any): UserAction => ({
	type: UserActionTypes.USER_ADD_NEW_BCC_SUCCESS_OFF
});

export const userDeleteBccRequest = () => ({
	type: UserActionTypes.USER_DELETE_BCC_REQUEST
});

export const userCreateScheduleRequest = (): UserAction => ({
	type: UserActionTypes.USER_CREATE_SCHEDULE_REQUEST
});

export const userCreateScheduleSuccess = (payload: any): UserAction => ({
	type: UserActionTypes.USER_CREATE_SCHEDULE_SUCCESS,
	payload
});

export const userCreateScheduleCalAuth = (): UserAction => ({
	type: UserActionTypes.USER_CREATE_SCHEDULE_CAL_AUTH
});

export const adminAccessAccountRequest = (payload: any): UserAction => ({
	type: UserActionTypes.USER_ADMIN_ACCESS_ACCOUNT_REQUEST,
	payload
});

export const adminAccessAccountFailure = (payload: any): UserAction => ({
	type: UserActionTypes.USER_ADMIN_ACCESS_ACCOUNT_FAILURE,
	payload
});

export const adminAccessAccountClearStatus = (): UserAction => ({
	type: UserActionTypes.USER_ADMIN_ACCESS_ACCOUNT_CLEAR_STATUS
});

export const userGetNewCommunications = (): UserAction => ({
	type: UserActionTypes.USER_GET_NEW_COMMUNICATIONS
});

export const userGetNewCommunicationsSuccess = (payload): UserAction => ({
	type: UserActionTypes.USER_GET_NEW_COMMUNICATIONS_SUCCESS,
	payload
});

export const userGetNotifications = (): UserAction => ({
	type: UserActionTypes.USER_GET_NOTIFICATIONS
});

export const userGetNotificationsSuccess = (payload: any): UserAction => ({
	type: UserActionTypes.USER_GET_NOTIFICATIONS_SUCCESS,
	payload
});

export const userPostNotificationsRead = (payload: any): UserAction => ({
	type: UserActionTypes.USER_POST_NOTIFICATIONS_READ,
	payload
});

export const userCheckUserExists = (payload): UserAction => ({
	type: UserActionTypes.USER_CHECK_USER_EXISTS,
	payload
});

export const userCheckUserExistsSuccess = (payload): UserAction => ({
	type: UserActionTypes.USER_CHECK_USER_EXISTS_SUCCESS,
	payload
});

export const userSignUpFacebookFreemium = (payload): UserAction => ({
	type: UserActionTypes.USER_SIGN_UP_FACEBOOK_FREEMIUM,
	payload
});

export const userVerifySignupEmail = (token: any): UserAction => ({
	type: UserActionTypes.USER_VERIFY_SIGNUP_TOKEN,
	token
});

export const createUserAccounts = (payload: any): UserAction => ({
	type: UserActionTypes.USER_ADMIN_CREATE_ACCOUNTS_REQUEST,
	payload
});

export const createUserAccountsFailure = (payload: any): UserAction => ({
	type: UserActionTypes.USER_ADMIN_CREATE_ACCOUNTS_FAILURE,
	payload
});

export const createUserAccountsSuccess = (payload: any): UserAction => ({
	type: UserActionTypes.USER_ADMIN_CREATE_ACCOUNTS_SUCCESS,
	payload
});

export const userGenerateOtpSecret = (): UserAction => ({
	type: UserActionTypes.USER_GENERATE_OTP_SECRET
});

export const userGenerateOtpSecretSuccess = (payload: {
	otpAuthUrl: string;
	otpBase32Secret: string;
}): UserAction => ({
	type: UserActionTypes.USER_GENERATE_OTP_SECRET_SUCCESS,
	payload
});

export const userGenerateOtpSecretFailure = (): UserAction => ({
	type: UserActionTypes.USER_GENERATE_OTP_SECRET_FAILURE
});

export const userEnableOtp = (payload: { otp: string }): UserAction => ({
	type: UserActionTypes.USER_ENABLE_OTP,
	payload
});

export const userEnableOtpSuccess = (payload: string[]): UserAction => ({
	type: UserActionTypes.USER_ENABLE_OTP_SUCCESS,
	payload
});

export const userEnableOtpFailure = (): UserAction => ({
	type: UserActionTypes.USER_ENABLE_OTP_FAILURE
});

export const userDeactivateOtp = (): UserAction => ({
	type: UserActionTypes.USER_DEACTIVATE_OTP
});

export const userDeactivateOtpSuccess = (): UserAction => ({
	type: UserActionTypes.USER_DEACTIVATE_OTP_SUCCESS
});

export const userDeactivateOtpFailure = (): UserAction => ({
	type: UserActionTypes.USER_DEACTIVATE_OTP_FAILURE
});

export const userClearOtpSuccessFailureStates = (): UserAction => ({
	type: UserActionTypes.USER_CLEAR_OTP_SUCCESS_FAILURE_STATES
});

export const userClearOtpState = (): UserAction => ({
	type: UserActionTypes.USER_CLEAR_OTP_STATE
});

export const userAddOtpStateToken = (payload: {
	otpStateToken: string;
	email: string;
}): UserAction => ({
	type: UserActionTypes.USER_ADD_OTP_STATE_TOKEN,
	payload
});

export const userVerifyOtp = (payload: {
	otp: string;
	email: string;
	otpStateToken: string;
}): UserAction => ({
	type: UserActionTypes.USER_VERIFY_OTP,
	payload
});

export const userVerifyOtpFailure = (payload: string): UserAction => ({
	type: UserActionTypes.USER_VERIFY_OTP_FAILURE,
	payload
});

export const userResetOtp = (payload: {
	recoveryCode: string;
	email: string;
	otpStateToken: string;
}): UserAction => ({
	type: UserActionTypes.USER_RESET_OTP,
	payload
});

export const userResetOtpFailure = (payload: string): UserAction => ({
	type: UserActionTypes.USER_RESET_OTP_FAILURE,
	payload
});

export const updateEmailSendingMethod = (payload: {
	userEmail: string;
	emailSystem: string;
}): UserAction => ({
	type: UserActionTypes.USER_UPDATE_EMAIL_SENDING_METHOD,
	payload
});

export const updateUserActiveStatus = (payload: {
	userEmail: string;
	action: string;
}): UserAction => ({
	type: UserActionTypes.USER_UPDATE_USER_ACTIVE_STATUS,
	payload
});
